import React from 'react'

import './styles.scss'
const roundTo = require('round-to')

function Star(props) {
  // Max Star = 0.7 (otherwise looks like whole star)
  const v = props.value >= 0.9 && props.value !== 1 ? 0.7 : props.value
  return (
    <div className='star'>
      <div className='starbackground' />
      <div className='starfront' style={{ width: `${v * 100}%` }} />
    </div>
  )
}

export function Stars(props) {
  const stars = []
  for (let i = 0; i < 5; i++) {
    const v = roundTo(props.rating - i, 1)
    stars.push(<Star value={v > 1 ? 1 : v < 0 ? 0 : v} key={i} />)
  }
  return <div className='stars'>{stars}</div>
}

export default Stars
